<template>
    <div id="navbar">
      <div id="navbarControls" v-if="!showNavToggle">
        <div id="leaderboardButton" :class="{'disabled': disableNavItems}" @click="toggleLeaderboardModal">LEADERBOARD</div>
        <div id="helpButton" :class="{'disabled': disableNavItems}" @click="toggleHelpModal">HELP</div>
        <div id="userButton" :class="{'disabled': disableNavItems}" @click="toggleUserModal" v-if="currentUser && (currentView === 'welcome' || currentView === 'gameover')">MY ACCOUNT</div>
        <div id="logoutButton" :class="{'disabled': disableNavItems}" @click="currentUser ? toggleLogoutModal() : toggleLoginModal()">{{currentUser ? 'LOGOUT' : 'LOGIN'}}</div>
      </div>
      <div id="mobileNavbarContainer" v-if="showNavToggle">
        <Transition name="fade" mode="out-in">
          <div id="mobileNavbarToggle" @click="toggleMobileNavOptions" v-if="!showMobileNavOptions">
            ☰
          </div>
          <div id="mobileNavbarControls" v-else v-click-outside="toggleMobileNavOptions">
            <div id="mobileLeaderboardButton" :class="{'disabled': disableNavItems}" @click="toggleLeaderboardModal()" >LEADERBOARD</div>
            <div id="mobileHelpButton" :class="{'disabled': disableNavItems}" @click="toggleHelpModal()">HELP</div>
            <div id="mobileUserButton" :class="{'disabled': disableNavItems}" @click="toggleUserModal()" v-if="currentUser && (currentView === 'welcome' || currentView === 'gameover')">MY ACCOUNT</div>
            <div id="mobileLogoutButton" :class="{'disabled': disableNavItems}" @click="currentUser ? toggleLogoutModal() : toggleLoginModal()">{{currentUser ? 'LOGOUT' : 'LOGIN'}}</div>
          </div>
        </Transition>
      </div>
    </div>
</template>

<script>
import vClickOutside from 'click-outside-vue3'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Navbar',
  components: {

  },
  computed: {
    ...mapGetters([
      'moduleTitle',
      'moduleAssetFolderName',
      'currentView',
      'currentUser',
      'disableNavItems',
      'clientWidth',
      'breakpoints',
    ]),
    showNavToggle(){
      const theNavbar = this;
      return (theNavbar.clientWidth <= theNavbar.breakpoints.tab)
    }
  },
  methods: {
    ...mapActions([
      'toggleLeaderboardModal',
      'toggleHelpModal',
      'toggleLoginModal',
      'toggleLogoutModal',
      'toggleUserModal',
    ]),
    toggleMobileNavOptions(){
      const theNavbar = this;
      theNavbar.showMobileNavOptions = !theNavbar.showMobileNavOptions
    }
  },
  mounted(){

  },
  beforeUnmount(){

  },
  data: function(){
    return {
      showMobileNavOptions: false,
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
}
</script>

<style scoped>
  #navbar{
    position: fixed;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    left: 0;
    right: 0;
    top: 100px;
    height: 50px;
    padding: 0 10px;
    justify-content: center;
    align-items: center;
    z-index: 50;
  }

  #navbarControls, #mobileNavbarContainer{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-self: flex-end;
  }

  #mobileNavbarControls{
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: center;
  }

  #leaderboardButton, #helpButton, #userButton, #logoutButton, #mobileLeaderboardButton, #mobileHelpButton, #mobileUserButton, #mobileLogoutButton{
    cursor: pointer;
    font-weight: bold;
    color: #fff;
    font-size: 14px;
    margin: 0px 10px;
  }

  #mobileNavbarToggle{
    color: #fff;
    cursor: pointer;
    font-size: 35px;
    font-weight: bold;
    line-height: 1em;
  }

  .disabled{
    opacity: .8;
    pointer-events: none;
  }

  @media screen and (max-width: 1023px){
    #navbar{
      top: 25px;
    }
  }
</style>